import React from 'react';
import { Box, Typography } from '@mui/material';

import { TOKENS } from '../theme';
import AuditLogList from '../shared/AuditLogList';

// Session → toolbar "Employee Audit Log": everything that changed on this shift —
// the employee's own edits/deletes (transactions, ticket outs, bonuses,
// point matches incl. machine corrections, raffles), manager edits, and
// transfers sent / accepted / rejected.
export default function SessionAuditLogScreen({
  session,
  sessionNumber,
  auditLog,
  customers,
  employees,
  manageBonusList,
}) {
  return (
    <Box sx={{ pb: 2 }}>
      <Box sx={{ px: 2, pt: 1.5, pb: 1.5 }}>
        {/* The toolbar already says "Employee Audit Log". */}
        <Typography
          sx={{ fontSize: 20, fontWeight: 700, color: TOKENS.slate900 }}
        >
          {session?.name} · Session #{sessionNumber || '—'}
        </Typography>
      </Box>
      <Box sx={{ px: 2 }}>
        <AuditLogList
          auditLog={auditLog}
          customers={customers}
          employees={employees}
          manageBonusList={manageBonusList}
        />
      </Box>
    </Box>
  );
}
